import { Ability } from '@casl/ability';

function abilitiesPlugin(Vue, providedAbility) {
  var ability = providedAbility || new Ability([]);
  var watcher = new Vue({
    data: {
      rules: []
    }
  });

  ability.on('updated', function (_ref) {
    var rules = _ref.rules;

    watcher.rules = rules;
  });

  Object.defineProperty(Vue.prototype, '$ability', { value: ability });

  Vue.mixin({
    methods: {
      $can: function $can() {
        var _$ability;

        watcher.rules = watcher.rules; // create dependency
        return (_$ability = this.$ability).can.apply(_$ability, arguments);
      }
    }
  });
}

export { abilitiesPlugin };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@casl/vue/index.js
// module id = bsU8
// module chunks = 2